import { FormikValues } from 'formik'
import { isNil } from 'lodash-es'

import {
  AdGroupCreateInput,
  BudgetCapping as BudgetCappingEnum,
  ChannelType,
  DailyBudgetType,
} from '../../../__generated__/graphql'
import prepareFormValues from '../../../utils/prepareFormValues'
import { sanitizeUrl } from '../../../utils/urlUtils'

export type AdgroupFormValues = FormikValues & {
  channels?: ChannelType[]
  campaignId?: string | number
}

export const toAdGroupCreateInput = (formValues: FormikValues, campaignId: string | number): AdGroupCreateInput => {
  const cleanData = prepareFormValues(formValues) as AdgroupFormValues

  const channels = cleanData.channels ?? []
  const channelEmail = channels.includes(ChannelType.Email)
  const channelWeb = channels.includes(ChannelType.Web)

  const updatedDailyBudget =
    cleanData.dailyBudgetType === DailyBudgetType.Fixed && (cleanData.dailyBudget ?? 0) > 0
      ? cleanData.dailyBudget
      : null
  const updatedDailyBudgetType = updatedDailyBudget === null ? DailyBudgetType.Open : DailyBudgetType.Fixed

  const updatedBudgetCapping =
    cleanData.budgetCappingType === BudgetCappingEnum.Open ||
    cleanData.budgetCapping === 0 ||
    isNil(cleanData.budgetCapping)
      ? null
      : cleanData.budgetCapping

  return {
    campaignId,
    channelEmail,
    channelWeb,
    contentStrategy: cleanData.contentStrategy,
    endDate: cleanData.endDate,
    format: cleanData.format,
    isActive: cleanData.isActive,
    name: cleanData.name,
    network: cleanData.network,
    priorityId: cleanData.priorityId,
    redirectUrl: sanitizeUrl(cleanData.redirectUrl),
    startDate: cleanData.startDate,
    costType: cleanData.costType,
    costValue: cleanData.costValue,
    dailyBudget: updatedDailyBudget,
    dailyBudgetType: updatedDailyBudgetType,
    budgetCapping: updatedBudgetCapping,
    budgetCappingType: cleanData.budgetCappingType,
  }
}
